import { Component, OnInit, ViewChild } from '@angular/core';
import DateTime  from 'typescript-dotnet-es6/System/Time/DateTime'
import {  RaService,DownloadService } from '../../core';
import { AlertComponent } from '../../common/component/alert/alert.component';


@Component({
  selector: 'app-failed-email-notifications',
  templateUrl: './failed-email-notifications.component.html',
  styleUrls: ['./failed-email-notifications.component.scss']
})
export class FailedEmailNotificationsComponent implements OnInit {

  constructor(
    private service: RaService,
    private downloadService: DownloadService,

  ) { }
  public initialFilterStartDate: Date ;
  public earliestDate: Date;
  public latestDate: Date;
  public selectedDate: Date;

  ngOnInit() {
    this.earliestDate = DateTime.now.addDays(-60).date.toJsDate();
    this.initialFilterStartDate = this.earliestDate;
    this.latestDate = DateTime.now.date.toJsDate();
    this.selectedDate = this.initialFilterStartDate;

  }
  @ViewChild(AlertComponent, { static: true }) alerter: AlertComponent;

  onBuildReport(){

    this.downloadService.downloadFailedEmailReport(this.selectedDate)
    .subscribe(()=>{}, (err)=>{console.log(err);
      this.alerter.showAlertMessage(3000, "Error creating report for download.", 2);

    });
  }
  onStartDateChange(value: Date): void{

    this.selectedDate = value;
  }

}
